import React from 'react'
import {Button, Stack} from '@mui/material'
import PlayArrow from '@mui/icons-material/PlayArrow'
import Pause from '@mui/icons-material/Pause'
import RestartAlt from '@mui/icons-material/RestartAlt'
import SkipNext from '@mui/icons-material/SkipNext'

export default function Controls({controlText, toggleTimer, resetLevel, skipLevel, confirmReset, disabled = false}: {confirmReset?: () => void; disabled?: boolean; controlText: string; toggleTimer: () => void; resetLevel: () => void; skipLevel: () => void}) {
  return <Stack direction="row" sx={{flexWrap: 'wrap', gap: {xs: 1, sm: 2}, '& > button': {flex: '1 1 6rem', py: 1.5}}}>
    <Button disabled={disabled} variant="contained" startIcon={controlText === 'Pause' ? <Pause/> : <PlayArrow/>} onClick={toggleTimer}>{controlText}</Button>
    <Button disabled={disabled} variant="outlined" startIcon={<RestartAlt/>} onClick={event => event.detail === 0 && confirmReset ? confirmReset() : resetLevel()}>Reset</Button>
    <Button disabled={disabled} variant="outlined" startIcon={<SkipNext/>} onClick={skipLevel}>Skip</Button>
  </Stack>
}
